// Nom de fichier d'un badge : « Nom-Prénom-CODE-Événement.pdf ». On retire uniquement les
// caractères réservés (Windows/macOS) et de contrôle qui casseraient le nom de fichier — les
// lettres accentuées restent (elles passent partout). Les champs vides sont ignorés.
// Voir le ticket « FO/BO — Téléchargement de badge : nommer le fichier ».
const RESERVED = '\\/:*?"<>|'

const sanitizePart = value =>
  Array.from(String(value ?? ''))
    // On garde les caractères imprimables non réservés ; on jette les caractères de
    // contrôle (code < 32 ou 127) et les réservés Windows/macOS.
    .filter(ch => {
      const code = ch.codePointAt(0)
      return code > 31 && code !== 127 && !RESERVED.includes(ch)
    })
    .join('')
    .replace(/\s+/g, ' ')
    .trim()

export const badgeFileName = ({ lastName, firstName, code, eventName } = {}) => {
  const base = [lastName, firstName, code, eventName]
    .map(sanitizePart)
    .filter(Boolean)
    .join('-')
  return `${base || 'badge'}.pdf`
}

// window.open sur une URL blob ne peut pas porter de nom de fichier : on force un vrai
// téléchargement via l'attribut download d'un <a> temporaire.
export const downloadFile = (url, fileName) => {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  a.remove()
}
